document.addEventListener('DOMContentLoaded', function() {
  const readMoreContainers = document.querySelectorAll('.read-more-container');

  readMoreContainers.forEach(container => {
    const readMoreLink = container.querySelector('.read-more-link');
    const readLessLink = container.querySelector('.read-less-link');

    readMoreLink.style.display = 'inline';
    readLessLink.style.display = 'none';

    readMoreLink.addEventListener('click', function() {
      container.classList.add('expanded');
      readMoreLink.style.display = 'none';
      readLessLink.style.display = 'inline';
    });

    readLessLink.addEventListener('click', function() {
      container.classList.remove('expanded');
      readMoreLink.style.display = 'inline';
      readLessLink.style.display = 'none';
    });
  });
});